export default {
      id: "term-life-insurance-usage",
      viewBox: "0 0 26 32",
      url: __webpack_public_path__ + "sprite.svg#term-life-insurance",
      toString: function () {
        return this.url;
      }
    }